import I18n from 'I18n';
import { List } from 'immutable';
import { memo } from 'react';
import { getProperty, getReference, getReferenceLabel } from 'reporting-data/v2/dataset/datasetRecords';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Alignments } from '../tableRecords';
import { getPropertyFormatter, isFormattableProperty
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../../formatters/propertyFormatter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'repo... Remove this comment to see the full error message
import { LINKS_FIELD } from 'reporting-data/v2/dataset/constants';
import { Metrics } from '../../../monitoring/Metrics';
import { SEARCH_LINK_CLICKED } from '../../../constants/trackingMetrics';
import styled from 'styled-components';
import { convertToTextAlign, getCellBlockSize } from '../tableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTd = styled.td.withConfig({
  displayName: "TableCell__StyledTd",
  componentId: "ji0jn2-0"
})(["background-color:", ";text-align:", ";block-size:", ";white-space:nowrap;font-size:", ";"], ({
  $backgroundColor
}) => $backgroundColor, ({
  $textAlign
}) => $textAlign, ({
  $isMobile
}) => getCellBlockSize($isMobile), ({
  $isMobile
}) => $isMobile ? '12px' : 'inherit');
const defaultRenderCell = args => {
  const {
    column,
    link,
    valueLabels,
    valueLinks,
    onPointClick,
    index,
    onTableCellLinkClick,
    value,
    isMobile
  } = args;
  const {
    align,
    onClick: onColumnClick
  } = column;
  const onClick = onPointClick || onColumnClick;
  const content = valueLinks.map((linkVal, key) => {
    let text;
    const label = valueLabels.get(key);
    if (valueLabels.get(key) === null || valueLabels.get(key) === undefined) {
      text = '-';
    } else if (onClick) {
      text = /*#__PURE__*/_jsx(Button, {
        onClick: () => onClick(args),
        use: "link",
        "data-test-id": `table-cell-${column.get('index')}-${index}`,
        children: label
      });
    } else if (linkVal || link) {
      text = /*#__PURE__*/_jsx(Link, {
        href: linkVal || link,
        external: true,
        onClick: () => {
          const trackingProperties = {
            objectId: String(value),
            linkClicked: linkVal || link
          };
          if (onTableCellLinkClick) {
            onTableCellLinkClick(trackingProperties);
          }
          Metrics.counter(SEARCH_LINK_CLICKED).increment();
        },
        "data-test-id": `table-cell-${column.get('index')}-${index}`,
        children: label
      });
    } else if (typeof label === 'boolean') {
      text = String(label);
    } else {
      text = label;
    }
    return /*#__PURE__*/_jsxs("span", {
      "data-test-id": `table-cell-wrapper-${column.get('index')}-${index}`,
      children: [key !== 0 && /*#__PURE__*/_jsx("span", {
        children: ", "
      }), text]
    }, key);
  });
  const conditionalFormatter = column.get('conditionalFormatter');
  const backgroundColor = conditionalFormatter && conditionalFormatter(value);
  const textAlign = convertToTextAlign(align);
  return align === Alignments.left ?
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(StyledTd, {
    $backgroundColor: backgroundColor,
    $textAlign: textAlign,
    $isMobile: isMobile,
    children: /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: 400,
      children: content
    })
  }) :
  /*#__PURE__*/
  // @bend-expect trellis-tokenized
  _jsx(StyledTd, {
    $backgroundColor: backgroundColor,
    $textAlign: textAlign,
    $isMobile: isMobile,
    children: content
  });
};
const TableCell = ({
  index,
  column,
  getOnPointClick,
  onTableCellLinkClick,
  isMobile
}) => {
  const {
    dataset,
    field,
    linkField,
    renderCell,
    useRawDataLabel
  } = column;
  const {
    data
  } = dataset;
  const row = data.get(index);
  const value = row.get(field);
  const link = linkField && row.get(linkField);
  const maybeFormattableProperty = getProperty(dataset, field);
  const property = isFormattableProperty(maybeFormattableProperty) && column.get('formattingObject') ? maybeFormattableProperty.set('formattingType', column.getIn(['formattingObject', 'type'])).set('formattingObject', column.get('formattingObject')) : maybeFormattableProperty;
  const valueList = List.isList(value) ? value : List([value]);
  const valueLabels = valueList.map(val => {
    if (useRawDataLabel && (!property.getIn(['formattingObject', 'type']) || property.getIn(['formattingObject', 'type']) === 'auto')) {
      return val;
    }
    if (property && property.getIn(['format', 'type']) === 'currency') {
      // Check currency property type for backend resolve
      const currencyPropertyName = property.getIn(['format', 'currencyCodeColumnName']);
      const currency = row.get(currencyPropertyName);
      const currencyReferenceKey = `${currency}|${val}`;
      if (getReference(dataset, field, currencyReferenceKey)) {
        return getReferenceLabel(dataset, field, currencyReferenceKey, val);
      }
    }
    if (property && property.get('type') === 'currency') {
      const currencyPropertyName = property.get('currencyCodeColumnName');
      const currency = currencyPropertyName ? row.get(currencyPropertyName) : undefined;
      if (currency && currency !== '@@MISSING@@' && I18n.formatIntlCurrency(val, {
        currencyCode: currency
      })) {
        return I18n.formatIntlCurrency(val, {
          currencyCode: currency
        });
      }
    }
    if (getReference(dataset, field, val)) {
      return getReferenceLabel(dataset, field, val);
    }
    const propertyFormatter = property && getPropertyFormatter(property) || (propertyValue => propertyValue);
    return propertyFormatter(val);
  });
  const valueLinks = valueList.map(val => {
    return row.getIn([LINKS_FIELD, field, String(val)], null);
  });
  const renderArgs = {
    index,
    column,
    row,
    value,
    link,
    valueLabels,
    valueLinks,
    field,
    dataset,
    onTableCellLinkClick,
    isMobile
  };
  const onPointClick = getOnPointClick ? getOnPointClick(renderArgs) : null;
  const defaultRender = () => defaultRenderCell(Object.assign({
    onPointClick
  }, renderArgs));
  return typeof renderCell === 'function' ? renderCell(Object.assign({
    defaultRender,
    onPointClick
  }, renderArgs)) : defaultRender();
};
export default /*#__PURE__*/memo(TableCell);